export const sendCardTo = [
  { label: 'Gift Recipient', value: 'recipient' },
  { label: 'Purchaser', value: 'purchaser' },
];
